import { render, staticRenderFns } from "./deep2.vue?vue&type=template&id=6182934c&scoped=true&"
import script from "./deep2.vue?vue&type=script&lang=js&"
export * from "./deep2.vue?vue&type=script&lang=js&"
import style0 from "./deep2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./deep2.vue?vue&type=style&index=1&id=6182934c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6182934c",
  null
  
)

export default component.exports